import React from 'react';

function FormSubmittedPage() {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="text-4xl font-bold text-center">
        Form Submitted!
      </div>
    </div>
  );
}

export default FormSubmittedPage;
